const parseMm = (str) => parseFloat(str);
const applyMm = (str, delta) => parseMm(str) + delta + "mm";

// Per-group corrections (px) applied to draggable text top/left positions.
// vertical._default.top = null → write the raw value unchanged (no unit conversion).
// horizontal._default = null → skip positioning entirely for unknown groups.
const DRAGGABLE_CORRECTIONS = {
  vertical: {
    gt6l: { top: 52.9, left: 37.8 },
    mt4: { top: 71.8, left: 71.8 },
    gt2t: { top: 41.5, left: 52.3 },
    gt8: { top: -5.7, left: 52.3 },
    gt12: { top: 4.9, left: 52.3 },
    gt10: { top: 321.26, left: 52.3 },
    _default: { top: null, left: 52.3 },
  },
  horizontal: {
    gt6l: { top: 35, left: 50 },
    gt12: { top: 54.5, left: 7 },
    gt2t: { top: 102.9, left: 50 },
    _default: null,
  },
};

function getInlayTopCorrection(inlayTop) {
  const top = parseFloat(inlayTop);
  if (!top || isNaN(top)) return 0;
  return -top;
}

function getDraggableCorrections(group, isHorizontal) {
  const table = isHorizontal
    ? DRAGGABLE_CORRECTIONS.horizontal
    : DRAGGABLE_CORRECTIONS.vertical;
  const key = Object.keys(table).find(
    (k) => k !== "_default" && group.includes(k)
  );
  return key ? table[key] : table._default;
}

function shiftMeasurements(inlay, delta) {
  inlay.style.top = applyMm(inlay.style.top, delta);

  for (let btn in inlay.btns) {
    inlay.btns[btn].style.top = applyMm(inlay.btns[btn].style.top, delta);
  }
  for (let led in inlay.leds) {
    inlay.leds[led].style.top = applyMm(inlay.leds[led].style.top, delta);
  }
  for (let bar in inlay.bargraph) {
    inlay.bargraph[bar].style.top = applyMm(
      inlay.bargraph[bar].style.top,
      delta
    );
    inlay.bargraph[bar].caption.style.top = applyMm(
      inlay.bargraph[bar].caption.style.top,
      delta
    );
  }
}

function draggableLeft(value, correction) {
  return parseInt(value) - correction;
}

function styleStr(obj, exclude = []) {
  return Object.keys(obj)
    .filter((k) => !exclude.includes(k))
    .map((k) => `${k}:${obj[k]}`)
    .join(";");
}

function renderDraggableText(text, group, isHorizontal) {
  const corr = getDraggableCorrections(group, isHorizontal);
  const topStr =
    corr && corr.top !== null
      ? draggableLeft(text.top, corr.top) + "px"
      : text.top;
  const leftStr = corr ? `left:${draggableLeft(text.left, corr.left)}px;` : "";
  return `<p style="z-index:100;position:absolute;top:${topStr};${leftStr}${styleStr(
    text.style
  )};">${text.content}</p>`;
}

function renderBtn(btn) {
  const { style, content } = btn;
  const { image } = style;
  const displayStyle = content["d-content"] ? "" : "display:none;";
  return (
    `<div class="gt-btn" style="position:absolute;${styleStr(style, [
      "content",
      "image",
    ])};">` +
    `<div class="gt-btn-img" style="background-position:${image["background-position"]};` +
    `height:${style.height};width:${style.width};` +
    `background-image:${image["background-image"]};` +
    `filter:${image["filter"]};background-size:${image["background-size"]};"></div>` +
    `<div class=" d-flex gt-btn-container ${content.style["justify-content"]} ${content.style["align-items"]}">` +
    `<p style="${styleStr(content.style, [
      "content",
    ])};${displayStyle}" class="btn_text">${content.content}</p>` +
    `</div></div>`
  );
}

function renderLed(led) {
  return `<div class="led" style="border:1px dashed grey;${styleStr(
    led.style
  )};"></div>`;
}

function renderBargraphEntry(
  bar,
  showBargraph,
  selectedBarGType,
  showBargraphCaptions
) {
  const isActive = showBargraph && selectedBarGType === bar.type;
  const captionActive = showBargraphCaptions && selectedBarGType === bar.type;
  return (
    `<div class="bar_g" style="${styleStr(bar.style)};display:${
      isActive ? "block" : "none"
    };" id="${bar.type}_${bar.id}"></div>` +
    `<div class="bar_g_caption" style="${styleStr(bar.caption.style)};display:${
      captionActive ? "block" : "none"
    };" id="${bar.id}">${bar.caption.content}</div>`
  );
}

function makeContent(selected_inlay, group) {
  const isHorizontal = selected_inlay.style.horizontal;
  const wrapperStyle =
    group === "gt6l"
      ? "position:relative;min-width:200px;margin:15px;min-height:200px;float:left;"
      : `position:relative;margin:5px;float:left;${
          isHorizontal ? "margin-left:50px;" : ""
        }`;

  const cutline = !isHorizontal
    ? '<div class="cutline"></div><p class="cuttext">Schnittlinie nur für GTS-Serie</p>'
    : "";

  const draggableTexts = Object.values(selected_inlay.draggableTexts)
    .map((text) => renderDraggableText(text, group, isHorizontal))
    .join("");
  const btns = Object.values(selected_inlay.btns).map(renderBtn).join("");
  const leds = Object.values(selected_inlay.leds).map(renderLed).join("");
  const bargraph = Object.values(selected_inlay.bargraph)
    .map((bar) =>
      renderBargraphEntry(
        bar,
        selected_inlay.showBargraph,
        selected_inlay.selectedBarGType,
        selected_inlay.showBargraphCaptions
      )
    )
    .join("");

  return (
    `<div style="${wrapperStyle}" class="${group}">` +
    `<div class="inlay ${group}" style="background-repeat:no-repeat;${styleStr(
      selected_inlay.style
    )};">` +
    `<div class="gt8BlackTriangles" style="width:100%;height:100%"></div>` +
    cutline +
    draggableTexts +
    `</div>` +
    btns +
    leds +
    bargraph +
    `</div>`
  );
}

// Page grid is 3×3 = 9 units. gt12 is double-height (2 units). gt6l expands
// into 1–3 sub-inlays counted individually. Everything else (incl. gt10) = 1 unit.
const PAGE_UNITS = 9;

function getInlayUnits(inlay) {
  if (inlay.name.includes("gt6l"))
    return Array.isArray(inlay.inlay) ? inlay.inlay.length : 1;
  if (inlay.group.includes("gt12")) return 2;
  return 1;
}

function getInlaySize(inlay) {
  const data = Array.isArray(inlay.inlay) ? inlay.inlay[0] : inlay.inlay;
  return parseMm(data.style.width) * parseMm(data.style.height);
}

function sortInlaysByGroupThenSize(inlays) {
  return [...inlays].sort((a, b) => {
    if (a.group !== b.group) return a.group.localeCompare(b.group);
    return getInlaySize(a) - getInlaySize(b);
  });
}

function packIntoPages(sortedInlays) {
  const pages = [];
  let currentPage = [];
  let currentUnits = 0;

  for (const inlay of sortedInlays) {
    const units = getInlayUnits(inlay);
    if (currentUnits + units > PAGE_UNITS && currentPage.length > 0) {
      pages.push(currentPage);
      currentPage = [];
      currentUnits = 0;
    }
    currentPage.push(inlay);
    currentUnits += units;
  }
  if (currentPage.length > 0) pages.push(currentPage);
  return pages;
}

function buildInlayHtml(inlay) {
  const group = inlay.group;
  if (!inlay.name.includes("gt6l")) {
    const correction = getInlayTopCorrection(inlay.inlay.style.top);
    if (correction !== 0) {
      shiftMeasurements(inlay.inlay, correction);
      const html = makeContent(inlay.inlay, group);
      shiftMeasurements(inlay.inlay, -correction);
      return html;
    }
    return makeContent(inlay.inlay, group);
  }
  let ledIdx = 0;
  return inlay.inlay
    .map((subInlay) => {
      for (const led in subInlay.leds) {
        subInlay.leds[led].style.left = inlay.preview.leds[ledIdx].style.left;
        ledIdx++;
      }
      const correction = getInlayTopCorrection(subInlay.style.top);
      if (correction !== 0) {
        shiftMeasurements(subInlay, correction);
        const html = makeContent(subInlay, group);
        shiftMeasurements(subInlay, -correction);
        return html;
      }
      return makeContent(subInlay, group);
    })
    .join("");
}

function printAllInlays(inlays) {
  const printEl = document.getElementById("print");
  const sorted = sortInlaysByGroupThenSize(inlays);
  const pages = packIntoPages(sorted);

  printEl.innerHTML = pages
    .map((page, idx) => {
      const isLast = idx === pages.length - 1;
      const pageHtml = page.map(buildInlayHtml).join("");
      return `<div class="print-page" style="${
        isLast ? "" : "page-break-after:always;"
      }">${pageHtml}</div>`;
    })
    .join("");
}

function print() {
  window.print();
  let printEl = document.getElementById("print");

  printEl.innerHTML = "";
}

export { print, printAllInlays };
